import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    // Default to dark theme when no preference was saved yet
    return savedTheme ? savedTheme === 'dark' : true;
  });

  useEffect(() => {
    const applyTheme = () => {
      const body = document.body;
      const darkStylesheet = document.getElementById('dark-styles');

      if (isDarkMode) {
        body.classList.add('dark-mode');
        if (!darkStylesheet) {
          const link = document.createElement('link');
          link.id = 'dark-styles';
          link.rel = 'stylesheet';
          link.href = '/vitrine_assets/styles-dark.css';
          document.head.appendChild(link);
        }
      } else {
        body.classList.remove('dark-mode');
        if (darkStylesheet) {
          darkStylesheet.remove();
        }
      }

      localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
    };

    applyTheme();
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(prev => !prev);
  };

  const value = {
    isDarkMode,
    toggleTheme,
    setIsDarkMode
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
